/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfPayers } from '../../models/data-page-of-payers';

export interface FinancialGetAllPayers$Params {
}

export function financialGetAllPayers(http: HttpClient, rootUrl: string, params?: FinancialGetAllPayers$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPayers>> {
  const rb = new RequestBuilder(rootUrl, financialGetAllPayers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfPayers>;
    })
  );
}

financialGetAllPayers.PATH = '/financial/getPayers';
